export const BUSINESS_DASHBOARD_URL = 'https://dashboard.tulink.xyz';

export const NAV_LINKS = [
  { label: 'Product', href: '#product' },
  { label: 'How it works', href: '#journey' },
  { label: 'Stories', href: '#stories' },
  { label: 'Business', href: BUSINESS_DASHBOARD_URL },
];
